export default __webpack_public_path__ + "static/media/promocionAlarma4Mobile.7b721994.png";